import React from 'react'

import { useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'

import { useMenu, useUpdateMenu } from 'api/menuApi'

import { Notification } from 'components/Notification'
import { Loading } from 'components/loading'
import { ContentWrapper } from 'components/layout'

import { MenuForm } from './components/MenuForm'

function normalizeData(data) {
    if(!data) {
        return null
    }
    const { status, locale, file } = data 
    return {
        status,
        locale,
        file: [file]
    }
}

export default function ViewMenu() {
  const intl = useIntl();
  const { id } = useParams();

  const { data, isLoading, isFetching } = useMenu({
    id,
  })
  const updateMutation = useUpdateMenu(id)

  const handleSubmit = (values) => {
    updateMutation.mutate(values, {
      onSuccess() {
        Notification(
          'success',
          intl.formatMessage({
            id: `message.updateSuccess`,
          }),
        );
      },
      onError(error) {
        Notification(
          'error',
          error.message ?? intl.formatMessage({ id: 'message.commonError' }),
        );
      },
    });
  };

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (!data) {
    return null;
  }

  return (
    <ContentWrapper title={'Chỉnh sửa'}>
        <MenuForm
            onSubmit={handleSubmit}
            isLoading={updateMutation.isLoading}
            initialValues={normalizeData(data)}
            relatedEntityId={data.id}
            typeUpdate={'update'}
        />
    </ContentWrapper>
  )
} 